// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    projectId: 'reef-tracker',
    appId: '1:51927216710:web:2265081e01444ce4211047',
    storageBucket: 'reef-tracker.appspot.com',
    apiKey: 'AIzaSyDilRWM-n_IvkzWa4rmSXdq2hPiS-Xg_pk',
    authDomain: 'reef-tracker.firebaseapp.com',
    messagingSenderId: '51927216710',
    measurementId: 'G-KNHY34294H',
  },
  // RevenueCat API keys - get these from RevenueCat Dashboard -> Project Settings -> API Keys
  // TODO: Replace with your actual API keys before deploying
  revenueCat: {
    iosApiKey: 'appl_HBDjKuqcuDfkMMtrczmqsjZqoJE',
    androidApiKey: 'goog_fvChjtrgJXdRNnYLWieMMqkPMGQ',
    // Web Billing Sandbox API Key - for testing only, do not use in production
    webApiKey: 'rcb_sb_OqpkstGOdHHxmIijNtMbAZiMP',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
